import React, { lazy, Suspense } from 'react';

const LazyLogout = lazy(() => import('./Logout'));

const Logout = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyLogout {...props} />
  </Suspense>
);

export default Logout;
